import React, {
  useEffect,
  useState
} from "react";


import {
  Box,
  Typography,
  CircularProgress
} from "@mui/material";


import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip
} from "recharts";


import {
  getCategoryReport
} from "../../services/reportService";
import uiConfig from "../../config/uiConfig";






function CategoryReport({ departmentId = null }){



const [data,setData] = useState([]);

const [loading,setLoading] = useState(true);






const COLORS = uiConfig.chartPalette;







useEffect(()=>{


const loadCategory = async()=>{


try{


const response = await getCategoryReport(departmentId);


setData(response);



}

catch(error){


console.error(

"Category Report Error:",

error

);


}

finally{


setLoading(false);


}


};



loadCategory();


},[departmentId]);









if(loading){


return (

<Box

height="100%"

display="flex"

justifyContent="center"

alignItems="center"

>

<CircularProgress/>

</Box>

);


}








return(


<Box

height="100%"

>






<Typography

sx={{

fontSize:14,

fontWeight:600,

color:"text.primary",

mb:2

}}

>

Category Distribution

</Typography>









<ResponsiveContainer

width="100%"

height={250}

>


<PieChart>






<Pie

data={data}

dataKey="value"

nameKey="name"

cx="50%"

cy="45%"

innerRadius={55}

outerRadius={85}

paddingAngle={4}

>



{

data.map((item,index)=>(


<Cell

key={index}

fill={

COLORS[index % COLORS.length]

}

/>


))


}



</Pie>







<Tooltip />








<Legend

verticalAlign="bottom"

height={35}

wrapperStyle={{

fontSize:12

}}

/>







</PieChart>


</ResponsiveContainer>








</Box>


);


}



export default CategoryReport;